import { render, staticRenderFns } from "./EditStaffDialog.vue?vue&type=template&id=92dbef7c&scoped=true&"
import script from "./EditStaffDialog.vue?vue&type=script&lang=ts&"
export * from "./EditStaffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dbef7c",
  null
  
)

export default component.exports